import { useSubscription } from 'villus';
import { notificationTaskFragment } from '~/utils/notificationTaskTypes';

export default function () {
  subscribeToNotificationTaskUpserted();
}

function subscribeToNotificationTaskUpserted() {
  const { me } = useAuth();

  useSubscription(
    {
      query: graphql(`
        subscription NotificationTaskUpserted($tenantId: UUID!) {
          notificationTaskUpserted(notificationTaskTenantId: $tenantId) {
            ...NotificationTaskFragment
          }
        }
      `, [notificationTaskFragment]),
      variables: { tenantId: me?.value?.tenantId as string },
    },
    ({ data, error }) => {
      if (error) {
        console.error(error);
        return;
      }

      const msg = data?.notificationTaskUpserted;
      if (msg && msg.type !== MessageType.SYSTEM_TEST) {
        useEventPublish('notificationTask:upserted', msg);
      }
    },
  );
}
